<template>
    <CardPage :section="13" :page="3" :nextDisabled="nextDisabled">
        <p>
            Below are some signs of a healthy relationship. What are the 3 most important things to you?
        </p>
        <div
            v-for="(key, index) in signsOrder"
            :key="index"
            class="px-2 py-1 mb-1"
            @click="select(signs[key])"
            :class="{ secondary: !signs[key].selected, 'primary white--text': signs[key].selected }"
            v-ripple
        >
            {{ signs[key].text }}
        </div>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        signs: get('section13/signs'),
        signsOrder: get('section13/signsOrder')
    },
    methods: {
        nextDisabled() {
            return !this.$store.get('section13/maxSignsSelected');
        },
        select(sign) {
            this.$store.commit('section13/selectSign', sign);
        }
    }
};
</script>
